import React from "react";
import { Form } from "semantic-ui-react";
import classnames from "classnames";

import Styles from "./FormLabelWithDivider.module.scss";
import { Tooltip } from "@/shared/components";

type Props = {
  width?: number;
  id?: string;
  htmlFor?: string;
  title?: string;
  subTitle?: string;
  tooltip?: string | null | undefined;
  centered?: boolean;
  divider?: boolean;
  desktop?: boolean;
  leftAlign?: boolean;
  rightAlign?: boolean;
  themed?: boolean;
  largeIcons?: boolean;
  above?: boolean;
  inline?: boolean;
  secondary?: boolean;
  className?: string;
  very?: boolean;
};

export function FormLabelWithDivider(props: Props) {
  const {
    // width = 6,
    id,
    htmlFor,
    title,
    subTitle,
    tooltip,
    centered,
    leftAlign,
    rightAlign,
    desktop,
    divider,
    themed,
    above,
    largeIcons,
    inline,
    secondary,
    className,
  } = props;
  return (
    <Form.Field
      // width={width}
      className={classnames(
        {
          [Styles.centered]: centered,
          [Styles.leftAlign]: leftAlign,
          [Styles.rightAlign]: rightAlign,
          [Styles.divided]: divider,
          [Styles.aboveField]: above,
          [Styles.container]: true,
          [Styles.inline]: inline,
        },
        className
      )}
    >
      <label
        id={id}
        htmlFor={htmlFor}
        className={classnames({
          [Styles.label]: !desktop,
          [Styles.above]: above,
          [Styles.forLargeIcons]: largeIcons,
          [Styles.desktop_label]: desktop,
          "cs-customer-themed": themed,
          [Styles.inline]: inline,
        })}
      >
        {title}
        {subTitle && (
          <>
            <br />
            <br />
            {desktop ? <span className={Styles["subTitle"]}>{subTitle}</span> : subTitle}
          </>
        )}
      </label>
      {tooltip && (
        <Tooltip
          id={"missing-data-field" + id + title}
          className={secondary ? Styles.popup : ""}
          tooltip={<span className={Styles.tooltipInfo}>{tooltip}</span>}
        />
      )}
    </Form.Field>
  );
}

export default FormLabelWithDivider;
